module.exports = __webpack_public_path__ + "static/media/banner1a.24ed9ecd.png";